import React from 'react';
import {InputAdornment, TextField} from "@mui/material";
import T from 'i18n-react';
import 'components/UI/Input/EngineDisplacementInput.css'

const EngineDisplacementInput = ({setEngineCC, form, engineCC}) => {

    const changeValue = event => {
        event.target.value = event.target.value?.replace(/\D/g, ''); // allow only numbers, so remove all non-numeric characters
        setEngineCC(event.target.value);
    }

    return (
        <TextField
            className={'engineDisplacementField'}
            name={'engineDisplacement'}
            type={'text'}
            value={engineCC}
            onChange={changeValue}
            placeholder={T.translate("vinQueryComponent.engineCC")}
            InputProps={{
                endAdornment: (
                    <InputAdornment position={'end'}>
                        <p>{T.translate('default.engineCCUnitDesc')}</p>
                    </InputAdornment>
                ),
            }}
            onKeyDown={event => {
                if (event.key === 'Tab') { // Do not close the dropdown when pressing Tab
                    event.stopPropagation();
                }
            }}
            inputProps={{
                min: 0,
                form: form,
            }}
        />
    )

}

export default EngineDisplacementInput;
